<template>
  <div id="app">
    <keep-alive>
      <router-view v-wechat-title="$t($route.meta.title)" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-wechat-title="$t($route.meta.title)" v-if="!$route.meta.keepAlive" />
    <loading-default v-show="isLoading" class="overPage" />
    <net-default class="overPage" />

    
  </div>
</template>

<script>
import bus from "@/util/bus";
import NetDefault from "@/components/NetDefault";
import LoadingDefault from "@/components/LoadingDefault";

export default {
  name: "App",
  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    bus.$on("showLoading", () => this.showLoading());
    bus.$on("hideLoading", () => this.hideLoading());
  },
  mounted(){
  },
  methods: {
    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    }
  },
  beforeDestroy() {
    bus.$off("showLoading", this.showLoading);
    bus.$off("hideLoading", this.hideLoading);
  },
  components: {
    NetDefault: NetDefault,
    LoadingDefault: LoadingDefault
  }
};
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background:#F1F1F2;
  min-height: 100vh;
}
</style>
